package dev.wyns.ventrova.ui.web

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import dev.wyns.ventrova.resources.Res
import dev.wyns.ventrova.resources.inter_bold
import dev.wyns.ventrova.resources.inter_medium
import dev.wyns.ventrova.resources.inter_regular
import dev.wyns.ventrova.resources.inter_semibold
import dev.wyns.ventrova.resources.roboto_bold
import dev.wyns.ventrova.resources.roboto_medium
import dev.wyns.ventrova.resources.roboto_regular
import dev.wyns.ventrova.resources.roboto_semibold
import org.jetbrains.compose.resources.Font

/** Roboto, the Android system font, bundled for the Android look in mobile browsers. */
@Composable
fun robotoFontFamily(): FontFamily = FontFamily(
    Font(Res.font.roboto_regular, FontWeight.Normal),
    Font(Res.font.roboto_medium, FontWeight.Medium),
    Font(Res.font.roboto_semibold, FontWeight.SemiBold),
    Font(Res.font.roboto_bold, FontWeight.Bold),
)

/** Inter, the closest open alternative to SF Pro (which may not be redistributed). */
@Composable
fun interFontFamily(): FontFamily = FontFamily(
    Font(Res.font.inter_regular, FontWeight.Normal),
    Font(Res.font.inter_medium, FontWeight.Medium),
    Font(Res.font.inter_semibold, FontWeight.SemiBold),
    Font(Res.font.inter_bold, FontWeight.Bold),
)
